import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: "root",
})
export class InvitemailService {
  constructor(private afStore: AngularFirestore) {}

  sendMail(eventId: string, to: string, subject: string, html: string) {
    return this.afStore.collection(`event/${eventId}/invitemail`).add({
      to: to,
      message: {
        subject: subject,
        html: html,
      },
    });
  }

  sendMail$heuro(eventId: string, to: string, subject: string, message: string, url?: string) {
    return this.afStore.collection(`event/${eventId}/heuromail`).add({
      to: to,
      message: {
        subject: subject,
        html: url ? this.getInviteMailWithCoupons$heuro(message, url) : this.getInviteMail$heuro(message)
      },
    });
  }

  sendMail$uliege(eventId: string, to: string, subject: string, message: string, url?: string) {
    return this.afStore.collection(`event/${eventId}/uliegemail`).add({
      to: to,
      message: {
        subject: subject,
        html: url ? this.getInviteMailWithCoupons$uliege(message, url) : this.getInviteMail$uliege(message)
      },
    });
  }

  sendMail$sintjozef(eventId: string, to: string, subject: string, message: string, url?: string) {
    return this.afStore.collection(`event/${eventId}/sintjozefmail`).add({
      to: to,
      message: {
        subject: subject,
        html: url ? this.getInviteMailWithCoupons$sintjozef(message, url) : this.getInviteMail$sintjozef(message)
      },
    });
  }

  getInviteMail$sintjozef(message: string) {
    return `
      <!DOCTYPE html>
<html lang="nl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Swipedrinks Bonnen ontvangen!</title>
    <style>
        body { font-family: Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
        .container { width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; }
        /* Hier passen we de achtergrondkleur van de header aan */
        .header {
    background-color: #1FB9DB; /* Lichtblauw */
    padding: 20px;
    text-align: center;
    color: #ffffff; /* Wit */
}

        .header img { max-width: 250px; }
        /* Pas de kleur van de tekst Swipedrinks aan */
        .header h2 { color: #00103A; }
        .content { padding: 20px; }
        h1 { color: #333333; }
        p { line-height: 1.6; color: #555555; }
        .cta img { width: 150px; height: auto; margin: 10px auto; display: block; }
        .footer { background-color: #f4f4f4; padding: 10px; text-align: center; font-size: 0.9em; color: #777777; }
        .footer a { color: #007bff; text-decoration: none; }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <img src="https://sjcaalst.be/wp-content/uploads/2020/03/Sint-Jozefscollege_logo_Algemeen_rgb-600x139.png" alt="Swipedrinks Logo">
         
        </div>
        <div class="content">
            <h1>Beste,</h1>
            <p> Je wordt uitgenodigd om krediet aan te kopen via de app van het Sint-jozefscollege in Aalst.</p>
<p>${message}</p>
<p> Hier is je url: <a href="https://sintjozef.bonnen.app">Klik hier</a></p>

<div style="text-align: center;">
    <img src="https://img.nieuwsblad.be/_Cg7kVOixGrTPFbxknjKDVFg1oE=/960x640/smart/https%3A%2F%2Fstatic.nieuwsblad.be%2FAssets%2FImages_Upload%2F2024%2F06%2F14%2F8da718ab-f0d7-4198-ae60-54ac7c666596.jpg" width="300" height="auto">
</div>            
            <h2>Hoe ga je te werk</h2>
            <ul>
                <li>Koop en gebruik je bonnen met <a href="https://sintjozef.bonnen.app">onze app </a> via je browser </li>
                <li>Je kan de app makkelijk installeren op je smartphone</li>
                <li>Betaal makkelijk met de app of zet bonnen op een QR-kaart/ leerlingenkaart.</li>

               
            </ul>


       

                  <p> Voor meer info:  </>
            
            <a href="https://sjcaalst.be/" class="cta">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThtIBQ9GW-HOWnZTkK9RUUi-ZiwaHhjbbNc4DtTyK_jM2M5nCiYvDBIvFHz7-kewCFjX0&usqp=CAU" alt="Meer info" width="150" height="auto">
            </a>
           
        </div>
        <div class="footer">
            <p>&copy; 2024 Coupon Solutions. Alle rechten voorbehouden.</p>
            <p>Volg ons op <a href="https://www.facebook.com/Swipedrinks">Facebook</a> en <a href="https://www.instagram.com/swipedrinks/">Instagram</a>.</p>
            <p><a href="https://swipedrinks.com/blog/hoe-je-account-deleten-how-to-delete-account">Afmelden voor deze mails</a></p>
        </div>
    </div>
</body>
</html>
    `;
  }

  getInviteMailWithCoupons$sintjozef(message: string, url?: string) {
    return `
    <!DOCTYPE html>
<html lang="nl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Swipedrinks Bonnen ontvangen!</title>
    <style>
        body { font-family: Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
        .container { width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; }
        /* Hier passen we de achtergrondkleur van de header aan */
        .header {
    background-color: #1FB9DB; /* Lichtblauw */
    padding: 20px;
    text-align: center;
    color: #ffffff; /* Wit */
}

        .header img { max-width: 250px; }
        /* Pas de kleur van de tekst Swipedrinks aan */
        .header h2 { color: #00103A; }
        .content { padding: 20px; }
        h1 { color: #333333; }
        p { line-height: 1.6; color: #555555; }
        .cta img { width: 150px; height: auto; margin: 10px auto; display: block; }
        .footer { background-color: #f4f4f4; padding: 10px; text-align: center; font-size: 0.9em; color: #777777; }
        .footer a { color: #007bff; text-decoration: none; }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <img src="https://sjcaalst.be/wp-content/uploads/2020/03/Sint-Jozefscollege_logo_Algemeen_rgb-600x139.png" alt="Swipedrinks Logo">
         
        </div>
        <div class="content">
            <h1>Beste,</h1>
            <p> Je ontving zonet krediet! Open de link onderaan om het krediet te ontvangen.</p>
<p>${message}</p>
<p> Hier is je url: <a href="${url}">Klik op deze link</a></p>

<div style="text-align: center;">
    <img src="https://img.nieuwsblad.be/_Cg7kVOixGrTPFbxknjKDVFg1oE=/960x640/smart/https%3A%2F%2Fstatic.nieuwsblad.be%2FAssets%2FImages_Upload%2F2024%2F06%2F14%2F8da718ab-f0d7-4198-ae60-54ac7c666596.jpg" width="300" height="auto">
</div>            
            <h2>Hoe ga je te werk</h2>
            <ul>
                <li>Gebruik je bonnen met <a href="https://sintjozef.bonnen.app">onze app </a> via je browser </li>
                <li>Je kan de app makkelijk installeren op je smartphone</li>
                <li>Betaal makkelijk met de app of zet bonnen op de leerlingenkaart.</li>

               
            </ul>


       

                  <p> Voor meer info:  </>
            
            <a href="https://sjcaalst.be/" class="cta">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThtIBQ9GW-HOWnZTkK9RUUi-ZiwaHhjbbNc4DtTyK_jM2M5nCiYvDBIvFHz7-kewCFjX0&usqp=CAU" alt="Meer info" width="150" height="auto">
            </a>
           
        </div>
        <div class="footer">
            <p>&copy; 2024 Coupon Solutions. Alle rechten voorbehouden.</p>
            <p>Volg ons op <a href="https://www.facebook.com/Swipedrinks">Facebook</a> en <a href="https://www.instagram.com/swipedrinks/">Instagram</a>.</p>
            <p><a href="https://swipedrinks.com/blog/hoe-je-account-deleten-how-to-delete-account">Afmelden voor deze mails</a></p>
        </div>
    </div>
</body>
</html>

    `;
  }



  getInviteMail$heuro(message: string) {
    return `
      <!DOCTYPE html>
<html lang="nl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Swipedrinks Bonnen ontvangen!</title>
    <style>
        body { font-family: Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
        .container { width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; }
        /* Hier passen we de achtergrondkleur van de header aan */
        .header { background-color: #CB0303; padding: 20px; text-align: center; color: #ffffff; }
        .header img { max-width: 250px; }
        /* Pas de kleur van de tekst Swipedrinks aan */
        .header h2 { color: #00103A; }
        .content { padding: 20px; }
        h1 { color: #333333; }
        p { line-height: 1.6; color: #555555; }
        .cta img { width: 150px; height: auto; margin: 10px auto; display: block; }
        .footer { background-color: #f4f4f4; padding: 10px; text-align: center; font-size: 0.9em; color: #777777; }
        .footer a { color: #007bff; text-decoration: none; }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <img src="https://swipedrinks.com/storage/app/media/uploaded-files/Heuro%20tekst%20rood.png" alt="Swipedrinks Logo">
            <h2>Heuro, de nieuwe Herzele bon! </h2>
        </div>
        <div class="content">
            <h1>Beste,</h1>
            <p> Je wordt uitgenodigd om lokaal aan te kopen in Herzele met HEURO's! </p>
<p>${message}</p>
<p> Via deze link kan je deelnemen! : <a href="https://heuro.bonnen.app">Klik hier</a></p>

            <img src="https://swipedrinks.com/storage/app/media/uploaded-files/Herzele%20en%20munt.png" alt="logo Herzele" width="550">
            
            <h2>Hoe ga je te werk</h2>
            <ul>
                <li>Gebruik de link in je webbrowser </li>
                <li>Heb je nog geen account, registreer je dan heel eenvoudig. Heb je al een Swipedrinks-account, dan kan je gewoon aanmelden met dit account. </li>
                <li>Koop eenvoudig Heuro's aan en koop lokaal in Herzele!! </li>
            </ul>


            <!-- Authentieke download knoppen met gelijke grootte -->

                  <p> Voor meer info:  </>
            
            <a href="https://www.herzele.be/digitale-herzele-munt" class="cta">
                <img src="https://static.nieuwsblad.be/Assets/Images_Upload/2019/03/18/logo_herzele.jpg?maxheight=411&maxwidth=731&scale=both" alt="Meer info" width="150" height="auto">
            </a>
           
        </div>
        <div class="footer">
            <p>&copy; 2024 Coupon Solutions. Alle rechten voorbehouden.</p>
            <p>Volg ons op <a href="https://www.facebook.com/Swipedrinks">Facebook</a> en <a href="https://www.instagram.com/swipedrinks/">Instagram</a>.</p>
            <p><a href="https://swipedrinks.com/blog/hoe-je-account-deleten-how-to-delete-account">Afmelden voor deze mails</a></p>
        </div>
    </div>
</body>
</html>
    `;
  }


  getInviteMailWithCoupons$heuro(message: string, url?: string) {
    return `
    <!DOCTYPE html>
<html lang="nl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Swipedrinks Bonnen ontvangen!</title>
    <style>
        body { font-family: Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
        .container { width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; }
        /* Hier passen we de achtergrondkleur van de header aan */
        .header { background-color: #CB0303; padding: 20px; text-align: center; color: #ffffff; }
        .header img { max-width: 250px; }
        /* Pas de kleur van de tekst Swipedrinks aan */
        .header h2 { color: #00103A; }
        .content { padding: 20px; }
        h1 { color: #333333; }
        p { line-height: 1.6; color: #555555; }
        .cta img { width: 150px; height: auto; margin: 10px auto; display: block; }
        .footer { background-color: #f4f4f4; padding: 10px; text-align: center; font-size: 0.9em; color: #777777; }
        .footer a { color: #007bff; text-decoration: none; }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <img src="https://swipedrinks.com/storage/app/media/uploaded-files/Heuro%20tekst%20rood.png" alt="Swipedrinks Logo">
            <h2>Heuro, de nieuwe Herzele bon! </h2>
        </div>
        <div class="content">
            <h1>Beste,</h1>
            <p> Je ontving zonet HEURO's! Open de link onderaan om deze bonnen te ontvangen.</p>
<p> ${message}</p>
<p> Hier is je bonnen-url: <a href="${url}">Klik op deze link</a></p>

            <img src="https://swipedrinks.com/storage/app/media/uploaded-files/Herzele%20en%20munt.png" alt="logo Herzele" width="550">
            
            <h2>Hoe ga je te werk</h2>
            <ul>
                <li>Gebruik de link in je webbrowser </li>
                <li>Heb je nog geen account, registreer je dan heel eenvoudig. Heb je al een Swipedrinks-account, dan kan je gewoon aanmelden met dit account.</li>
                <li>Na het maken van je account, ontvang je automatisch je bonnen. Koop ermee lokaal in Herzele! </li>
            </ul>


            <!-- Authentieke download knoppen met gelijke grootte -->

                  <p> Voor meer info:  </>
            
            <a href="https://www.herzele.be/digitale-herzele-munt" class="cta">
                <img src="https://static.nieuwsblad.be/Assets/Images_Upload/2019/03/18/logo_herzele.jpg?maxheight=411&maxwidth=731&scale=both" alt="Meer info" width="150" height="auto">
            </a>
           
        </div>
        <div class="footer">
            <p>&copy; 2024 Coupon Solutions. Alle rechten voorbehouden.</p>
            <p>Volg ons op <a href="https://www.facebook.com/Swipedrinks">Facebook</a> en <a href="https://www.instagram.com/swipedrinks/">Instagram</a>.</p>
            <p><a href="https://swipedrinks.com/blog/hoe-je-account-deleten-how-to-delete-account">Afmelden voor deze mails</a></p>
        </div>
    </div>
</body>
</html>
    `;
  }

  getInviteMail$uliege(message: string) {
    return `This message is empty. Please contact info@swipedrinks.com`;
  }


  getInviteMailWithCoupons$uliege(message: string, url?: string) {
    return `
      <!DOCTYPE html>
<html lang="nl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Swipedrinks Bonnen ontvangen!</title>
    <style>
        body { font-family: Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
        .container { width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; }
        /* Hier passen we de achtergrondkleur van de header aan */
        .header {
    background-color: #1FB9DB; /* Lichtblauw */
    padding: 20px;
    text-align: center;
    color: #ffffff; /* Wit */
}

        .header img { max-width: 250px; }
        /* Pas de kleur van de tekst Swipedrinks aan */
        .header h2 { color: #00103A; }
        .content { padding: 20px; }
        h1 { color: #333333; }
        p { line-height: 1.6; color: #555555; }
        .cta img { width: 150px; height: auto; margin: 10px auto; display: block; }
        .footer { background-color: #f4f4f4; padding: 10px; text-align: center; font-size: 0.9em; color: #777777; }
        .footer a { color: #007bff; text-decoration: none; }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <img src="https://swipedrinks.com/storage/app/media/uploaded-files/logo%20html.jpg" alt="Swipedrinks Logo">
            
        </div>
        <div class="content">
            <h1>Cher,</h1>
            <p> Vous venez de recevoir un crédit de l'Université de Liège ! Ouvrez le lien ci-dessous pour recevoir ce crédit.</p>
<p> ${message}</p>
<p> Voici l'URL pour réclamer le crédit: <a href="${url}">Cliquez sur ce lien</a></p>

            <img src="https://swipedrinks.com/storage/app/media/uploaded-files/logo%20html.jpg" alt="logo Herzele" width="550">
            
            <h2>Comment procéder</h2>
             <ul>
                <li>Utilisez le credit via uliege.bonnen.app dans votre navigateur </li>
                <li>Payez à la cantine avec l'application</li>
                
            </ul>


            <!-- Authentieke download knoppen met gelijke grootte -->

                     <p> Pour plus d'informations:  </>
            
            <a href="https://www.uliege.be/" class="cta">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNUOwO_3eviqlYOyLqLeEpXz6Eua6yTCbeJg&s" alt="Meer info" width="150" height="auto">
            </a>
           
        </div>
        <div class="footer">
            <p>&copy; 2024 Coupon Solutions. Tous droits réservés.</p>
            <p>Suivez-nous sur <a href="https://www.facebook.com/Swipedrinks">Facebook</a> et <a href="https://www.instagram.com/swipedrinks/">Instagram</a>.</p>
            <p><a href="https://swipedrinks.com/blog/hoe-je-account-deleten-how-to-delete-account">Se désabonner de ces emails</a></p>
        </div>
    </div>
</body>
</html>
    `;
  }
}
